import React from "react";
import "../../styles/messageModal.css";

interface MessageModalProps {
  isOpen: boolean;
  type?: "confirm" | "info" | "success" | "error" | "warning";
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({
  isOpen,
  type = "info",
  title,
  message,
  confirmText = "OK",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="message-modal-overlay">
      <div className={`message-modal ${type}`}>
        <h4>{title}</h4>
        <p>{message}</p>

        <div className="message-modal-actions">
          {type === "confirm" && (
            <button className="btn-cancel" onClick={onCancel}>
              {cancelText}
            </button>
          )}

          <button className="btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
